import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {HighlightCategory} from "../../../../static/highlightCategory.enum";
import {Highlight} from "../models/Highlight";

@Component({
  selector: 'cir-pub-highlight',
  templateUrl: './highlight.component.html',
  styleUrls: ['./highlight.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HighlightComponent implements OnInit {

  @Input()
  public highlight: Highlight;

  public HighlightCategory = HighlightCategory;

  constructor() { }

  ngOnInit() {
    if (!this.highlight.attributes.category) {
      this.highlight.attributes.category = HighlightCategory.UNKNOWN;
    }
  }

}
